import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import NoPage from "./pages/NoPage";
import Web from "./pages/Web";
import HostingPage from "./pages/Hosting";
import AIPage from "./pages/AI";
import DataAnalyticsPage from "./pages/Data";
import GatewayPage from "./pages/Gateway";
import ContactPage from "./pages/Contact";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        {/* You can add more routes here */}
        <Route path="/web" element={<Web />} />
        <Route path="/AI" element={<AIPage />} />
        <Route path="/dataAnalytics" element={<DataAnalyticsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/hosting" element={<HostingPage />} />
        <Route path="/gateway" element={<GatewayPage />} />        
        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
